unit Client.Core;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Modules, XData.Web.Connection, Math,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client, DateUtils,
  WEBLib.Dialogs, WEBLib.Forms, Auth.Service, WEBLib.Cookies, WEBLIB.Storage, WEBLib.ExtCtrls;

type
  TOnLineEvent = procedure(IsConnected: boolean) of object;

  TmodMain = class(TDataModule)
    connServer: TXDataWebConnection;
    wdsStranke: TXDataWebDataSet;
    wdsStrankeId: TIntegerField;
    wdsStrankeUporabniskoIme: TStringField;
    wdsStrankeGeslo: TStringField;
    wdsStrankePIN: TStringField;
    wdsStrankeIme: TStringField;
    wdsStrankePriimek: TStringField;
    wdsStrankeAktiven: TIntegerField;
    cliMain: TXDataWebClient;
    procedure WebDataModuleCreate(Sender: TObject);
    procedure connServerRequest(Args: TXDataWebConnectionRequest);
    procedure connServerConnect(Sender: TObject);
    procedure connServerError(Error: TXDataWebConnectionError);

    procedure OnLineChanged(Sender: TObject; AStatus: TOnlineStatus);
    procedure wdsStrankeAfterOpen(DataSet: TDataSet);
    procedure cliMainRequest(Request: TXDataClientRequest);
    procedure cliMainError(Error: TXDataClientError);
  private
    { Private declarations }
    FIsOnLine: boolean;
    FIsConnected: boolean;
    FOnOnLine: TOnLineEvent;
    FOnConnected: TOnLineEvent;
  public
    { Public declarations }

    StrankaId: integer;
    StrankaEmail: string;
    Stranka: TObject;

//    NalogId: integer;

    AuthService: TAuthService;

    function GetVar(TokenName: string): string;
    procedure SetVar(TokenName, Value: string);

    procedure Log(Txt: string);

    property OnConnected: TOnLineEvent read FOnConnected write FOnConnected;
    property IsOnline: boolean read FIsOnLine;
    property IsConnected: boolean read FIsConnected;

    procedure NastaviStranko(Email: string);
//    function VrniFrakcijeLokacije(LokacijaId: integer): TList<TFrakcija>;
    procedure PosljiNarocilo(Datum: TDateTime; LokacijaId, FrakcijaId: integer; Opombe: string);
    procedure Registriraj(Email, Geslo: string);
    procedure MenjavaGesla(Email, Geslo: string);
  protected procedure LoadDFMValues; override; end;

var
  modMain: TmodMain;

implementation

{%CLASSGROUP 'Vcl.Controls.TControl'}

uses Client.Settings, Main, Constants;

{$R *.dfm}

procedure TmodMain.WebDataModuleCreate(Sender: TObject);
begin
  AppSettings := TSettings.Create;
  Application.OnOnlineChange := OnLineChanged;

  AuthService := TAuthService.Create(connServer);

  connServer.URL := AppSettings.ServerURL;
  OnLineChanged(nil, osOnline);
end;

procedure TmodMain.OnLineChanged(Sender: TObject; AStatus: TOnlineStatus);
begin
  log('AStatus='+IntToStr(Ord(AStatus)));

  FIsOnLine := AStatus = osOnline;

  if AStatus = osOnline then begin
    if not connServer.Connected then begin
      log('Connecting to server '+connServer.URL);
      connServer.Connected := true;
    end;
  end;

  if Assigned(FOnConnected) then
    FOnConnected(FIsOnline);
end;

procedure TmodMain.PosljiNarocilo(Datum: TDateTime; LokacijaId, FrakcijaId: integer; Opombe: string);

  procedure OnResult(Response: TXDataClientResponse);
  begin
    frmmain.ShowNarocila;
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    ShowMEssage('Napaka pri oddaji naročila');
  end;

begin
  log('Pošiljanje naročila');
  cliMain.RawInvoke('IKamijoncinService.PosljiNarocilo', [Datum, LokacijaId, FrakcijaId, Opombe], @OnResult, @OnError);
end;

procedure TmodMain.Registriraj(Email, Geslo: string);

  procedure OnResult(Response: TXDataClientResponse);
  begin
    frmmain.ShowLogin;
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    ShowMessage('Napaka pri registraciji: '+Error.ErrorMessage);
  end;

begin
  log('Registracija novega uporabnika');
  cliMain.RawInvoke('IKamijoncinService.RegistrirajStranko', [Email, Geslo], @OnResult, @OnError);
end;

procedure TmodMain.cliMainError(Error: TXDataClientError);
begin
  Log(Error.ErrorCode+': '+Error.ErrorMessage);
end;

procedure TmodMain.cliMainRequest(Request: TXDataClientRequest);
begin
  Log(Request.Request.Uri);
end;

procedure TmodMain.connServerConnect(Sender: TObject);
begin
  log('Connected to server');
  FIsOnLine := true;
  FIsConnected := connServer.Connected;

  if Assigned(FOnConnected) then
    FOnConnected(FIsOnline);
end;

procedure TmodMain.connServerError(Error: TXDataWebConnectionError);
begin
  Log(Error.ErrorMessage);
  FIsOnLine := Application.IsOnline;
  FIsConnected := connServer.Connected;
end;

procedure TmodMain.connServerRequest(Args: TXDataWebConnectionRequest);
begin
  if AuthService.Authenticated then
    Args.Request.Headers.SetValue('Authorization', 'Bearer ' + AuthService.GetToken);
end;

function TmodMain.GetVar(TokenName: string): string;
var
  ls: TLocalStorage;
begin
(*  Result := '';
  ls := TLocalStorage.Create;
  try
    Result := ls.GetValue(TokenName);
  finally
    ls.free;
  end; *)
end;

procedure TmodMain.Log(Txt: string);
begin
//  if AppSettings.DevMode then
    Console.Log(Txt);
end;

procedure TmodMain.MenjavaGesla(Email, Geslo: string);
  procedure OnResult(Response: TXDataClientResponse);
  begin
    ShowMessage('Geslo je bilo zamenjano, prosim, prijavite se ponovno v program.');
    frmmain.ShowLogin;
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    ShowMessage('Napaka pri menjavi gesla: '+Error.ErrorMessage);
  end;

begin
  log('Registracija novega uporabnika');
  cliMain.RawInvoke('IKamijoncinService.MenjajGeslo', [Email, Geslo], @OnResult, @OnError);
end;

procedure TmodMain.NastaviStranko(Email: string);
begin
  wdsStranke.Close;
  wdsStranke.QueryString := '$filter=Email eq '+Email;
  wdsStranke.Load;
end;

procedure TmodMain.SetVar(TokenName, Value: string);
var
  ls: TLocalStorage;
begin
//  ClearMyToken; // clear it first - not strictly necessary
(*  ls := TLocalStorage.Create;
  try
    ls.SetValue(TokenName, Value);
  finally
    ls.free;
  end; *)
end;

(*function TmodMain.VrniFrakcijeLokacije(LokacijaId: integer): TList<TFrakcija>;

  procedure OnResult(Response: TXDataClientResponse);
  var
    Token: JS.TJSObject;
  begin
    Result := Response.Result;
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    Result := nil;
  end;

begin
  cliMain.RawInvoke('IKamijoncinService.NastaviKm', [LokacijaId]), @OnResult, @OnError);
end;
*)

procedure TmodMain.wdsStrankeAfterOpen(DataSet: TDataSet);
begin
  StrankaId := wdsStranke.FieldByName('Id').AsInteger;
  frmMain.ShowNarocila;
end;

procedure TmodMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  connServer := TXDataWebConnection.Create(Self);
  wdsStranke := TXDataWebDataSet.Create(Self);
  wdsStrankeId := TIntegerField.Create(Self);
  wdsStrankeUporabniskoIme := TStringField.Create(Self);
  wdsStrankeGeslo := TStringField.Create(Self);
  wdsStrankePIN := TStringField.Create(Self);
  wdsStrankeIme := TStringField.Create(Self);
  wdsStrankePriimek := TStringField.Create(Self);
  wdsStrankeAktiven := TIntegerField.Create(Self);
  cliMain := TXDataWebClient.Create(Self);

  connServer.BeforeLoadDFMValues;
  wdsStranke.BeforeLoadDFMValues;
  wdsStrankeId.BeforeLoadDFMValues;
  wdsStrankeUporabniskoIme.BeforeLoadDFMValues;
  wdsStrankeGeslo.BeforeLoadDFMValues;
  wdsStrankePIN.BeforeLoadDFMValues;
  wdsStrankeIme.BeforeLoadDFMValues;
  wdsStrankePriimek.BeforeLoadDFMValues;
  wdsStrankeAktiven.BeforeLoadDFMValues;
  cliMain.BeforeLoadDFMValues;
  try
    Name := 'modMain';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    Height := 423;
    Width := 594;
    connServer.SetParentComponent(Self);
    connServer.Name := 'connServer';
    connServer.URL := 'http://localhost:2001/kamijoncin';
    SetEvent(connServer, Self, 'OnConnect', 'connServerConnect');
    SetEvent(connServer, Self, 'OnRequest', 'connServerRequest');
    connServer.Left := 32;
    connServer.Top := 8;
    wdsStranke.SetParentComponent(Self);
    wdsStranke.Name := 'wdsStranke';
    wdsStranke.AfterOpen := wdsStrankeAfterOpen;
    wdsStranke.EntitySetName := 'Stranka';
    wdsStranke.Connection := connServer;
    wdsStranke.QueryTop := 1;
    wdsStranke.Left := 114;
    wdsStranke.Top := 8;
    wdsStrankeId.SetParentComponent(wdsStranke);
    wdsStrankeId.Name := 'wdsStrankeId';
    wdsStrankeId.FieldName := 'Id';
    wdsStrankeId.Required := True;
    wdsStrankeUporabniskoIme.SetParentComponent(wdsStranke);
    wdsStrankeUporabniskoIme.Name := 'wdsStrankeUporabniskoIme';
    wdsStrankeUporabniskoIme.FieldName := 'UporabniskoIme';
    wdsStrankeUporabniskoIme.Required := True;
    wdsStrankeUporabniskoIme.Size := 50;
    wdsStrankeGeslo.SetParentComponent(wdsStranke);
    wdsStrankeGeslo.Name := 'wdsStrankeGeslo';
    wdsStrankeGeslo.FieldName := 'Geslo';
    wdsStrankeGeslo.Required := True;
    wdsStrankeGeslo.Size := 50;
    wdsStrankePIN.SetParentComponent(wdsStranke);
    wdsStrankePIN.Name := 'wdsStrankePIN';
    wdsStrankePIN.FieldName := 'PIN';
    wdsStrankePIN.Size := 10;
    wdsStrankeIme.SetParentComponent(wdsStranke);
    wdsStrankeIme.Name := 'wdsStrankeIme';
    wdsStrankeIme.FieldName := 'Ime';
    wdsStrankeIme.Required := True;
    wdsStrankeIme.Size := 50;
    wdsStrankePriimek.SetParentComponent(wdsStranke);
    wdsStrankePriimek.Name := 'wdsStrankePriimek';
    wdsStrankePriimek.FieldName := 'Priimek';
    wdsStrankePriimek.Required := True;
    wdsStrankePriimek.Size := 50;
    wdsStrankeAktiven.SetParentComponent(wdsStranke);
    wdsStrankeAktiven.Name := 'wdsStrankeAktiven';
    wdsStrankeAktiven.FieldName := 'Aktiven';
    wdsStrankeAktiven.Required := True;
    cliMain.SetParentComponent(Self);
    cliMain.Name := 'cliMain';
    cliMain.Connection := connServer;
    SetEvent(cliMain, Self, 'OnError', 'cliMainError');
    SetEvent(cliMain, Self, 'OnRequest', 'cliMainRequest');
    cliMain.Left := 32;
    cliMain.Top := 62;
  finally
    connServer.AfterLoadDFMValues;
    wdsStranke.AfterLoadDFMValues;
    wdsStrankeId.AfterLoadDFMValues;
    wdsStrankeUporabniskoIme.AfterLoadDFMValues;
    wdsStrankeGeslo.AfterLoadDFMValues;
    wdsStrankePIN.AfterLoadDFMValues;
    wdsStrankeIme.AfterLoadDFMValues;
    wdsStrankePriimek.AfterLoadDFMValues;
    wdsStrankeAktiven.AfterLoadDFMValues;
    cliMain.AfterLoadDFMValues;
  end;
end;

end.
